export default {
  intentOverview: "개요",
  intentAnalytic: "분석",
  intentFilter: "필터",
  savedCompanyWebsite: "저장된 회사 웹사이트",
  companiesFound: "발견된 회사",
  companyFound: "발견된 회사",
  selectLists: "목록 선택...",
  chooseARangeOfTime: "기간 선택",
  greaterThan: "보다 큼",
  // intentIndustry: '산업',
  tabActivity: "활동",
  tabOverview: "개요",
  tabEmployees: "직원",
  tabContacts: "일반 연락처",
  tabTechnologies: "기술",
  intentStatistic: "통계",
  intentCampaign: "캠페인",
  newVisitors: "신규 방문자",
  recurringVisitors: "재방문자",
  mediocreLead: "평균 리드",
  sessionsTracked: "추적된 세션",
  sessionTracked: "추적된 세션",
  lastSeenOn: "마지막으로 본 날짜: ",
  firstSeenOn: "처음 본 날짜: ",
  viewTrackedWebSession: "추적된 웹 세션 보기",
  webSession: "웹 세션",
  client: "클라이언트",
  timeSpent: "소요 시간",
  pageviews: "페이지뷰",
  pageview: "페이지뷰",
  referrer: "리퍼러",
  sessions: "세션",
  session: "세션",
  visited: "방문함",
  AM: "오전",
  PM: "오후",
  companyDetails: "회사 세부 정보",
  overviewList: {
    location: "위치",
    industry: "산업",
    founded: "설립",
    ranking: "순위",
    size: "규모",
    revenue: "예상 매출",
    keywords: "키워드",
  },
  jobFunction: "직무",
  employeeLocation: "위치",
  contactEmail: "이메일",
  categoryAndTechnology: "카테고리 및 기술",
  firstDetected: "처음 감지됨",
  lastDetected: "마지막 감지됨",
  saved: "저장됨",
  addToContactList: "연락처 목록에 추가",
  noCampaignIdentified: "식별된 캠페인 없음",
  copyEmail: "이메일 복사",
  willBeSavedToTheFollowingSelectedLists:
    "다음 선택된 목록에 저장됩니다:",
  addToLists: "목록에 추가",
  noDataToDisplay: "표시할 데이터 없음",
  intentFounded: "설립",
  intentIndustry: "산업",
  intentLocation: "위치",
  intentRanking: "순위",
  noDetailsAvailableRightNow : "현재 이용 가능한 세부 정보가 없습니다. 나중에 다시 확인해주세요.",
  intentSize: "규모",
  applyFilters: "필터 적용",
  youCanEditTheseFilters:
    "언제든지 이 필터를 편집하여 결과를 구체화할 수 있습니다",
  installB2BDirectLeadFinder: "사이트에 B2B Direct Lead Finder 설치하기",
  addSite: "귀하의 웹사이트를 추가하세요",
  areYouSureYouWantToRemoveThisWebsite:
    "이 웹사이트를 제거하시겠습니까?",
  Cancel: "취소",
  installB2BLeadFinder: "B2B Lead Finder 설치",
  siteUrl: "사이트 URL",
  copyToClipboard: "클립보드에 복사",
  pleaseSelectAContactFirst: "먼저 연락처를 선택하세요",
  pasteCodeBelowIntoTheHead: "아래 코드를",
  ofEveryPageYouWishToTrackVisitorOn:
    "방문자를 추적하려는 모든 페이지의 <head>에 붙여넣으세요.",
  forWordpressWeRecommendInstalling:
    "워드프레스의 경우, ",
  pluginFromStefanoLissa: "Stefano Lissa의 플러그인 설치를 권장합니다.",
  afterInstallingAndActivating:
    "플러그인을 설치하고 활성화한 후, 워드프레스 대시보드에서",
  inYourWordPressDashboard: "로 이동하세요.",
  youWillSeeANumberOfTabs:
    "플러그인 인터페이스에 여러 탭이 보일 것입니다. 기본 'Head and footer' 탭에 있는지 확인한 다음 다음 코드 스니펫을 복사하여 붙여넣으세요:",
  settingHeaderAndFooter: "설정 → 헤더 및 푸터",
  dontForgetToClearYourCache: "캐시를 지우는 것을 잊지 마세요",
  ifYouAreUsingAnyCaChing: "만약 ",
  orSimilar:
    "등과 같은 캐싱 플러그인을 사용하고 있다면, 코드 스니펫을 설치한 후 캐시를 꼭 지워야 합니다!",
  GTMshouldAlreadyBeInstalled:
    "이 지침을 따르기 전에 Google 태그 관리자가 사이트에 이미 설치되어 있어야 합니다.",
  ifYouDontHaveGTM:
    "Google 태그 관리자가 아직 설치되어 있지 않다면, ",
  GTMsupportArticleAboutInstall:
    "Google 태그 관리자 지원 문서에서 설치 방법을 확인할 수 있습니다",
  signInToGTMAndClick:
    "Google 태그 관리자에 로그인하고 '새 태그 추가' 버튼을 클릭하세요. 다음으로,",
  clickWhereItSays: "'",
  chooseATagTypeToBeginSetup: "설정을 시작할 태그 유형을 선택하세요",
  andSelect: "'를 클릭하고 ",
  fromTheList:
    "목록에서 선택하세요. 그런 다음 다음 코드를 복사하여 텍스트 필드에 붙여넣으세요:",
  nextClick: "다음으로, '",
  giveTheTagAName: "를 클릭하세요. 태그 이름을 지정하고 '저장' 버튼을 클릭하세요.",
  dontForgetToPublishYourChange: "변경 사항을 게시하는 것을 잊지 마세요",
  afterCreateTheCustom: "커스텀 HTML 태그를 생성한 후, ",
  yourChanges: "변경 사항을 게시하는 것을 잊지 마세요!",
  submitAndPublish: "제출 및 게시",
  copySuccessfully: "성공적으로 복사되었습니다",
  addToCompanyList: "회사 목록에 추가",
  addToList: "목록에 추가",
  enterOrCreateList: "목록 입력 또는 생성",
  installCode: "코드 설치",
  wordpress: "워드프레스",
  googleTagManager: "Google 태그 관리자",
  noTechAreFound: "기술을 찾을 수 없습니다",
  updateSuccessfully: "성공적으로 업데이트되었습니다",
  enterJobFunction: "직무 입력",
  pinSuccessfully: "성공적으로 고정되었습니다",
  cancelPinSuccessfully: "성공적으로 고정 해제되었습니다",
  adsName: "광고 이름",
  utmTerm: "utm 용어",
  utmCampaign: "utm 캠페인",
  utmSource: "utm 소스",
  utmMedium: "utm 매체",
  enterNumber: "숫자 입력",
  enterName: "이름 입력",
  enterJobTitle: "직책 입력",
  areYouSureYouWantToRemovePeopleOfThisGroup:
    "이 그룹의 사람들을 제거하시겠습니까",
  areYouSureYouWantToRemoveCompanyOfThisGroup:
    "이 그룹의 회사를 제거하시겠습니까",
  byCancelingYouEnsureThatNoPeopleWillBeRemoved:
    "취소하면 아무도 제거되지 않습니다",
  byCancelingYouEnsureThatNoCompanyWillBeRemoved:
    "취소하면 회사가 제거되지 않습니다",
  howToGetStarted: "시작하는 방법",
  Data: "데이터",
  deactivateWebsite: "웹사이트 비활성화",
  areYouCertainAboutDeactivatinYourWebsite:
    "웹사이트를 비활성화하시겠습니까? 이로 인해 잠재적인 회사 활동을 더 이상 수신할 수 없게 됩니다.",
  byCancelingYouWillContinueToActivateAndUse:
    "취소하면 이 도구가 계속 활성화되고 사용됩니다",
  btnDeactivateNow: "지금 비활성화",
  yourTrialHasEnded: "체험 기간이 종료되었습니다",
  reactivateNow: "지금 재활성화",
  yourWebsiteHasBeenAutomaticallyInactivated:
    "웹사이트가 자동으로 비활성화되었습니다. 데이터를 계속 모니터링하기 위해 이 도구를 다시 활성화하시겠습니까?",
  Inactivated: "비활성화됨",
  onTrial: "체험 중",
  Active: "활성",
  youAreOnTrail: "7일 체험 기간 중입니다",
  yourTrailHasEnded: "체험 기간이 종료되었습니다",
  createNewWebIntent: "새 웹 의도 생성",
  clickOnTheButton: "1. (+) 버튼을 클릭하세요",
  typeInUrlOrWebAddress: "2. URL 또는 웹 주소를 입력하세요",
  theTrialWillActivate: "이 사이트의 7일 무료 체험판을 활성화하세요",
  siteUrlMustStartWithHttps: "사이트 URL은 https 또는 http로 시작해야 합니다",
  pleaseEnterASiteUrl: "사이트 URL을 입력하세요",
  noMoreData: "더 이상 데이터가 없습니다",
  pleaseEnterANewName: "새 이름을 입력하세요",
  pleaseSelectASearchName: "검색 이름을 선택하세요",
  clickToGetEmail: "클릭하여 이메일 받기",
  emailIsNotAvailable: "이메일을 사용할 수 없습니다",
  enterOrCreateLists: "목록 입력 또는 생성",
  viewMore: "더 보기",
  removeFromContactList: "연락처 목록에서 제거",
  willBeRemovedFromTheFollowingLists:
    "다음 목록에서 제거됩니다",
  removeFromLists: "목록에서 제거",
  pleaseSelectOrCreateAList: "목록을 선택하거나 생성하세요",
  chooseATriggerToMakeThisTagFire: "이 태그가 실행될 트리거를 선택하세요...",
  youWontBeChargedYet: "아직 요금이 청구되지 않습니다",
  youDontHaveEnoughCredits: "크레딧이 부족합니다",
  ThisEmailRequire: "이 이메일에는",
  TheseEmailsRequires: "이 이메일들에는",
  intentCredit: "크레딧이 필요합니다",
  intentCredits: "크레딧이 필요합니다",
  companyOverview: '회사 개요',

  // 新UI
  companyInsight: "회사 인사이트",
  companiesDetailHeader: "회사",
  updateData: "데이터 업데이트",
  discoverYourLeads: "리드 발견하기",
  similarCompanies: "유사한 회사",
  companyEmployees: "직원"
};